import { isString } from 'lodash';
import { makeApi } from 'src/http/api/internal/internal-http';
import HomeBandsRepository from 'src/repositories/personalization/home-bands/home-bands.repository';
import { homeBandItem } from 'src/types/home-band';
import { toBase64 } from 'src/utils/utils';
import { create } from 'zustand';

type States = {
  homeBands: homeBandItem[];
  homeBandToEdit: homeBandItem | null;
  isLoading: boolean;
  isLoadingCreate: boolean;
  isLoadingDetails: boolean;
};

type Actions = {
  findAll: () => Promise<void>;
  findOne: (id: string) => Promise<void>;
  resetHomeBandDetails: () => void;
  update: (id: string, homeBand: homeBandItem) => Promise<boolean>;
  create: (homeBand: homeBandItem) => Promise<boolean>;
};

type Store = Actions & States;

const initialValues = {
  homeBands: [],
  isLoading: false,
  isLoadingCreate: false,
  isLoadingDetails: false,
  homeBandToEdit: null,
};

const repository = new HomeBandsRepository(makeApi());

export const useHomeBandsStore = create<Store>((set) => ({
  ...initialValues,

  findAll: async () => {
    set({ isLoading: true });
    const response = await repository.findAllBands();
    if (response.isLeft()) {
      set({ isLoading: false });
      return;
    }

    set({ homeBands: response.value, isLoading: false });
  },
  
  findOne: async (id: string) => {
    set({ isLoadingDetails: true });
    const response = await repository.findOne(id);
    if (response.isLeft()) {
      set({ isLoadingDetails: false });
      return;
    }
    set({ homeBandToEdit: response.value, isLoadingDetails: false });
  },

  resetHomeBandDetails: () => {
    set({ homeBandToEdit: null });
  },

  update: async (id: string, homeBand: homeBandItem) => {
    set({ isLoadingCreate: true });
    if (homeBand?.icon && !isString(homeBand?.icon)) {
      try {
        const imgBase64: any = await toBase64(homeBand?.icon);
        const res: any = await repository.uploadFile({
          name: homeBand?.icon?.name,
          base64: imgBase64,
        });
        homeBand.icon = res.value.data.url;
      } catch (error) {
        console.error(error);
      }
    }
    const response = await repository.update(id, homeBand);
    if (response.isLeft()) {
      set({ isLoadingCreate: false });
      return false;
    }
    set({ isLoadingCreate: false });
    return true;
  },

  create: async (homeBand: homeBandItem) => {
    set({ isLoadingCreate: true });
    if (homeBand?.icon && !isString(homeBand?.icon)) {
      try {
        const imgBase64: any = await toBase64(homeBand?.icon);
        const res: any = await repository.uploadFile({
          name: homeBand?.icon?.name,
          base64: imgBase64,
        });
        homeBand.icon = res.value.data.url;
      } catch (error) {
        console.error(error);
      }
    }
    const response = await repository.create(homeBand);
    if (response.isLeft()) {
      set({ isLoadingCreate: false });
      return false;
    }
    set({ isLoadingCreate: false });
    return true;
  },
}));
